export default __webpack_public_path__ + "static/lefafa_3_5-5eefe68cd31ed612aa2d581e915bbbbd.webp";